module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_9016.b9b49461.png";